import {
  STRING,
  NUMBER,
  DATE,
  SELECT,
  BOOLEAN,
  DEFAULT,
  DATE_NUMBER
} from './constants'
import Number from './components/Number'
import Text from './components/Text'
import Dropdown from './components/Dropdown'
import Date from './components/Date'
import Radio from './components/Radio'
import DateNumber from './components/DateNumber'

export default {
  [STRING]: Text,
  [NUMBER]: Number,
  [SELECT]: Dropdown,
  [DATE]: Date,
  [BOOLEAN]: Radio,
  [DATE_NUMBER]: DateNumber,
  [DEFAULT]: Text
}
